{
	"asset": {
		"generator": "Khronos glTF Blender I/O v4.1.62",
		"version": "2.0"
	},
	"scene": 0,
	"scenes": [
		{
			"name": "Scene",
			"nodes": [0, 1]
		}
	],
	"nodes": [
		{
			"mesh": 0,
			"name": "head",
			"rotation": [0, 0, -0.1302284598350525, 0.9914840459823608],
			"scale": [2.052353620529175, 1.9658100605010986, 2.190054416656494],
			"translation": [0.5338709354400635, 5.526123046875, 0]
		},
		{
			"mesh": 1,
			"name": "Cube",
			"scale": [1.1018846035003662, 0.457942396402359, 1.3445651531219482],
			"translation": [0, 3.5786638259887695, 0]
		}
	],
	"materials": [
		{
			"doubleSided": true,
			"name": "Material.001",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.32843300700187683, 0.003659324487671256, 0.00805484876036644, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		},
		{
			"doubleSided": true,
			"name": "Material.005",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.7697931528091431, 0.8131840825080872, 0.767202615737915, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		},
		{
			"doubleSided": true,
			"name": "Material.002",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.8110413551330566, 0.6465651988983154, 0.4139544367790222, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		}
	],
	"meshes": [
		{
			"name": "Cube.002",
			"primitives": [
				{
					"attributes": {
						"POSITION": 0,
						"NORMAL": 1,
						"TEXCOORD_0": 2
					},
					"indices": 3,
					"material": 0
				},
				{
					"attributes": {
						"POSITION": 4,
						"NORMAL": 5,
						"TEXCOORD_0": 6
					},
					"indices": 7,
					"material": 1
				}
			]
		},
		{
			"name": "Cube",
			"primitives": [
				{
					"attributes": {
						"POSITION": 8,
						"NORMAL": 9,
						"TEXCOORD_0": 10
					},
					"indices": 11,
					"material": 2
				}
			]
		}
	],
	"accessors": [
		{
			"bufferView": 0,
			"componentType": 5126,
			"count": 596,
			"max": [1.0347496271133423, 0.7516860961914062, 1.0201958417892456],
			"min": [-1.0475636720657349, -0.7516862154006958, -1.025145173072815],
			"type": "VEC3"
		},
		{
			"bufferView": 1,
			"componentType": 5126,
			"count": 596,
			"type": "VEC3"
		},
		{
			"bufferView": 2,
			"componentType": 5126,
			"count": 596,
			"type": "VEC2"
		},
		{
			"bufferView": 3,
			"componentType": 5123,
			"count": 948,
			"type": "SCALAR"
		},
		{
			"bufferView": 4,
			"componentType": 5126,
			"count": 48,
			"max": [1.021920084953308, 0.7516860961914062, 1.0201958417892456],
			"min": [-1.0475636720657349, -0.6916858553886414, -1.0123156309127808],
			"type": "VEC3"
		},
		{
			"bufferView": 5,
			"componentType": 5126,
			"count": 48,
			"type": "VEC3"
		},
		{
			"bufferView": 6,
			"componentType": 5126,
			"count": 48,
			"type": "VEC2"
		},
		{
			"bufferView": 7,
			"componentType": 5123,
			"count": 72,
			"type": "SCALAR"
		},
		{
			"bufferView": 8,
			"componentType": 5126,
			"count": 645,
			"max": [1.3042104244232178, 2.0808119773864746, 2.0827388763427734],
			"min": [-1, -8.412923812866211, -2.082738161087036],
			"type": "VEC3"
		},
		{
			"bufferView": 9,
			"componentType": 5126,
			"count": 645,
			"type": "VEC3"
		},
		{
			"bufferView": 10,
			"componentType": 5126,
			"count": 645,
			"type": "VEC2"
		},
		{
			"bufferView": 11,
			"componentType": 5123,
			"count": 1284,
			"type": "SCALAR"
		}
	],
	"bufferViews": [
		{
			"buffer": 0,
			"byteLength": 7152,
			"byteOffset": 0,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 7152,
			"byteOffset": 7152,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 4768,
			"byteOffset": 14304,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1896,
			"byteOffset": 19072,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 576,
			"byteOffset": 20968,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 576,
			"byteOffset": 21544,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 384,
			"byteOffset": 22120,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 144,
			"byteOffset": 22504,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 7740,
			"byteOffset": 22648,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 7740,
			"byteOffset": 30388,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 5160,
			"byteOffset": 38128,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2568,
			"byteOffset": 43288,
			"target": 34963
		}
	],
	"buffers": [
		{
			"byteLength": 45856,
			"uri": "mushroom%20king.bin"
		}
	]
}
